import InventoryItem from 'src/models/inventory-item/InventoryItem'
import InventoryRecipeItem from 'src/models/inventory-recipe/InventoryRecipeItem'
import InventoryRecipeTrigger from 'src/models/inventory-recipe/InventoryRecipeTrigger'
import Model, { ID, Int, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'

export default class InventoryRecipe extends Model {
  static name = 'InventoryRecipe'

  static versioned = true

  static duplicatable = true

  static deletable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Inventory]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID
      },
      name: {
        type: String
      },
      inventoryItem: {
        type: InventoryItem,
        default: null,
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      inventoryRecipeTriggers: {
        type: [InventoryRecipeTrigger],
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      inventoryRecipeItems: {
        type: [InventoryRecipeItem],
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      preparationInventoryRecipe: {
        type: InventoryRecipe,
        default: null,
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      action: {
        type: String,
        default: null,
        input: true
      }
    }

    this.queries = {
      inventoryRecipeLibraryAll: {
        arguments: {
          limit: {
            type: Int,
            required: false
          },
          offset: {
            type: Int,
            required: false
          },
          orderBy: {
            type: String,
            required: false
          },
          descending: {
            type: Boolean,
            required: false
          },
          searchString: {
            type: String,
            required: false
          }
        },
        results: {
          inventoryItems: [InventoryRecipe]
        }
      }
    }

    this.paginate = true
  }
}
